<template>


    <b-modal class="modal fade" ref="vehicle-modal" centered size="md" scrollable style="padding: 10px">

        <template v-slot:modal-header>
            <slot name="header">
                <h6 class="modal-title">{{ vehicleEditMode == "add" ? "Add" : "Edit" }} Vehicle Details</h6>





            </slot>
            <slot name="close-button">
                <button type="button" class="close" @click="closeVehicleModal" data-dismiss="modal" aria-label="Close">
                    <span>×</span>
                </button>
            </slot>
        </template>

        <div data-tour="motor-vehicle-details" style="height: 500px; width: 100%; margin-bottom: 20px;" v-if="selectedItem != null">



            <b-row>

                <b-col class="less-padding">
                    <base-input rules="required" label="Vehicle Type" name="Vehicle Type"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.vehicleType" filterable @change="vehicleTypeChanged"
                            placeholder="Type to filter...">
                            <el-option v-for="option in filteredVehicleTypeOptions" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
            </b-row>

            <b-row v-if="selectedVehicleTypeCanBeRegistered">
                <b-col class="less-padding">
                    <base-input label="Is this vehicle registered?" name="Is this vehicle registered?"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="isVehicleRegistered" placeholder="Please select">
                            <el-option label="Yes" value="YES" />
                            <el-option label="No" value="NO" />
                        </el-select>
                    </base-input>
                </b-col>
            </b-row>

            <b-row>

                <b-col class="less-padding">


                    <!-- <base-input rules="required" label="Vehicle Type" name="Vehicle Type"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.vehicleType">
                            <el-option v-for="option in vehicleTypeOptions" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input> -->
                </b-col>
            </b-row>



            <b-row v-if="showFreightTask == true">
                <b-col class="less-padding">
                    <base-input rules="required" label="Freight Task" name="Freight Task"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.freightTask">
                            <el-option v-for="option in freightTaskOptions" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
            </b-row>





            <b-row>




                <b-col class="less-padding"
                    :style="this.selectedItem.vehicle.motorwebGlasses.registration == '' && this.selectedItem.vehicle.motorwebGlasses.vin == '' ? 'background-color:rgba(255, 68, 56, 0.10);' : 'background-color: white'">
                    <base-input name="Registration"
                        :rules="this.selectedItem.vehicle.motorwebGlasses.registration == '' && this.selectedItem.vehicle.motorwebGlasses.vin == '' ? 'required' : null"
                        label="Registration" v-model="selectedItem.vehicle.motorwebGlasses.registration"
                        inputGroupClasses="uBind-input" />

                    <div
                        style="position: absolute; right: 5px; top: 0px; font-size: 9pt;margin-top: 5px;font-weight: bold;">
                        and
                        / or</div>

                </b-col>




                <b-col class="less-padding"
                    :style="this.selectedItem.vehicle.motorwebGlasses.registration == '' && this.selectedItem.vehicle.motorwebGlasses.vin == '' ? 'background-color:rgba(255, 68, 56, 0.10);' : 'background-color: white'">
                    <base-input name="VIN"
                        :rules="this.selectedItem.vehicle.motorwebGlasses.registration == '' && this.selectedItem.vehicle.motorwebGlasses.vin == '' ? 'required' : null"
                        label="VIN" v-model="selectedItem.vehicle.motorwebGlasses.vin"
                        inputGroupClasses="uBind-input" />

                </b-col>


                <b-col class="less-padding">
                    <base-input name="Post Code" rules="required" label="Post Code"
                        v-model="selectedItem.vehicle.vehiclePostcode" inputGroupClasses="uBind-input" />

                </b-col>
            </b-row>

            <b-row>
                <b-col class="less-padding">
                    <base-input label="Make" name="Make" rules="required"
                        v-if="selectedItem.vehicle.vehicleType != 'SE1'"
                        v-model="selectedItem.vehicle.motorwebGlasses.make" inputGroupClasses="uBind-input" />

                    <base-input label="Make" v-if="selectedItem.vehicle.vehicleType == 'SE1'" name="Make"
                        inputGroupClasses="uBind-input">
                        <el-select @change="selectedItem.vehicle.motorwebGlasses.family = ''"
                            v-model="selectedItem.vehicle.motorwebGlasses.make">
                            <el-option v-for="option in carModels" :key="option.Make" :label="option.Make"
                                :value="option.Make">
                            </el-option>
                        </el-select></base-input>

                </b-col>

                <b-col class="less-padding">


                    <base-input label="Model" rules="required" v-if="selectedItem.vehicle.vehicleType == 'SE1'"
                        name="Model" inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.motorwebGlasses.family">
                            <el-option
                                v-for="option in (carModels.find(f => f.Make == selectedItem.vehicle.motorwebGlasses.make) ? carModels.find(f => f.Make == selectedItem.vehicle.motorwebGlasses.make).Models : [])"
                                :key="option" :label="option" :value="option">
                            </el-option>
                        </el-select></base-input>



                    <base-input label="Model" name="Model" rules="required"
                        v-if="selectedItem.vehicle.vehicleType != 'SE1'"
                        v-model="selectedItem.vehicle.motorwebGlasses.family" inputGroupClasses="uBind-input" />


                </b-col>

                <b-col class="less-padding">
                    <base-input label="Vehicle Year" rules="required" v-model="selectedItem.vehicle.vehicleYear"
                        inputGroupClasses="uBind-input" />

                </b-col>
            </b-row>

            <b-row>
                <b-col class="less-padding" md="6">
                    <base-input label="Variant" name="Variant"
                        v-model="selectedItem.vehicle.motorwebGlasses.variant"
                        inputGroupClasses="uBind-input" />
                </b-col>
                <b-col class="less-padding" md="6">
                    <base-input label="Style" name="Style"
                        v-model="selectedItem.vehicle.motorwebGlasses.style"
                        inputGroupClasses="uBind-input" />
                </b-col>
            </b-row>

            <b-row>
                <b-col class="less-padding" md="12">
                    <base-input
                        label="Accessories/Fitout"
                        name="Accessories/Fitout"
                        v-model="accessoriesInput"
                        :disabled="noAccessoriesChecked"
                        inputGroupClasses="uBind-input"
                    >
                        <template #label>
                            Accessories/Fitout
                            <el-tooltip
                                placement="top"
                                content="Describe any accessories or specialised fit-out. This can affect premium. Tick No Accessories if none apply."
                            >
                                <span class="accessories-info-hint">(i)</span>
                            </el-tooltip>
                        </template>
                    </base-input>
                    <b-form-checkbox
                        class="mt-1"
                        :checked="noAccessoriesChecked"
                        @change="onNoAccessoriesChange"
                    >
                        No Accessories
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <b-row v-if="!noAccessoriesChecked">
                <b-col class="less-padding" md="12">
                    <base-input
                        :prependIcon="'fas fa-dollar-sign'"
                        type="text"
                        inputmode="decimal"
                        label="Accessories Sum Insured"
                        name="Accessories Sum Insured"
                        v-model="accessoriesSumInsuredInput"
                        :preserveCursor="true"
                        :selectOnFocus="true"
                        inputGroupClasses="uBind-input"
                    />
                </b-col>
            </b-row>

            <b-row v-if="showFreightTask == true">
                <b-col class="less-padding">
                    <base-input label="Operating Radius for this Vehicle" name="Operating Radius for this Vehicle"
                        rules="required" inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.operatingRadius" placeholder="Please select">
                            <el-option v-for="option in radiusOfOperation" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="less-padding">
                    <base-input :prependIcon="'fas fa-dollar-sign'" type="text" inputmode="decimal" rules="required"
                        label="Sum Insured (Market Value)" v-model="sumInsuredInput" @blur="sumInsuredChanged"
                        :preserveCursor="true" :selectOnFocus="true" inputGroupClasses="uBind-input" />



                </b-col>
            </b-row>

            <b-row>
                <b-col class="less-padding">
                    <base-input :prependIcon="'fas fa-dollar-sign'" disabled type="text" rules="required"
                        label="Basic Excess" v-model="selectedItem.vehicle.basicExcess"
                        inputGroupClasses="uBind-input" />



                </b-col>
            </b-row>

            <b-row v-if="askOwnTrailer">

                <b-col class="less-padding" :md="ownTrailer == 'YES' ? '6' : '12'">




                    <base-input rules="required" label="Do you own the trailer?" name="Own Trailer"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="ownTrailer">
                            <el-option label="Please select" :value="null" />
                            <el-option label="Yes" value="YES" />
                            <el-option label="No" value="NO" />
                        </el-select>
                    </base-input>
                </b-col>

                <b-col v-if="ownTrailer == 'YES'" class="less-padding" md="6">

                    <base-input type="text" inputmode="decimal" rules="required" label="Trailer Sum Insured ($)"
                        v-model="trailerSumInsuredInput" :preserveCursor="true" :selectOnFocus="true"
                        inputGroupClasses="uBind-input" />
                </b-col>
            </b-row>


            <b-row v-if="showFreightTask == true">
                <b-col class="less-padding" md="12">
                    <base-input rules="required" label="No Claims Bonus" name="No Claims Bonus"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="noClaimsBonus">
                            <el-option v-for="option in noClaimsBonusOptions" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>


                </b-col>

            </b-row>





            <b-row v-if="showFreightTask == true">
                <b-col class="less-padding">
                    <div class="form-control-label" style="font-size: 12pt;margin-bottom:10px">Additional Information
                    </div>



                </b-col>
            </b-row>

            <b-row v-if="showFreightTask == true">
                <b-col class="less-padding" md="12">
                    <base-input rules="required"
                        label="Do you require an increased Dangerous/Hazardous Goods liability limit for this vehicle (Excludes Dangerous Goods classes 1, 6.2 & 7)?"
                        name="Dangerous Goods" inputGroupClasses="uBind-input">
                        <el-select v-model="dangerousGoods">
                            <el-option label="Please select" :value="null" />
                            <el-option label="Yes" value="YES" />
                            <el-option label="No" value="NO" />
                        </el-select>
                    </base-input>



                </b-col>

            </b-row>

            <b-row v-if="dangerousGoods == 'YES'">
                <b-col class="less-padding" md="12">
                    <base-input rules="required"
                        label="What dangerous goods limit is required on this vehicle (Excludes cover on dangerous goods classes 1, 6.2, 7)?"
                        name="Dangerous Goods Liability" inputGroupClasses="uBind-input">
                        <el-select v-model="dangerousGoodsLimit">
                            <el-option v-for="option in dangerousGoodsOptions" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>


                </b-col>

            </b-row>

            <b-row v-if="showFreightTask == true">
                <b-col class="less-padding" md="12">
                    <base-input rules="required"
                        label="Do you require Downtime/Business Interruption cover for this vehicle?"
                        name="Downtime Cover" inputGroupClasses="uBind-input">
                        <el-select v-model="businessInterruption">
                            <el-option label="Please select" :value="null" />
                            <el-option label="Yes" value="YES" />
                            <el-option label="No" value="NO" />
                        </el-select>
                    </base-input>



                </b-col>

            </b-row>

            <b-row v-if="businessInterruption == 'YES'">
                <b-col class="less-padding" md="12">
                    <base-input rules="required" label="Downtime Months" name="Downtime Months"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="downTimeMonths">
                            <el-option value="1">1 Month</el-option>
                            <el-option value="2">2 Months</el-option>
                            <el-option value="3">3 Months</el-option>
                            <el-option value="4">4 Months</el-option>
                        </el-select>
                    </base-input>





                </b-col>

            </b-row>

            <b-row v-if="businessInterruption == 'YES'">
                <b-col class="less-padding">
                    <base-input label="Downtime Benefit per month (Up to $20,000 per month)"
                        name="Downtime Benefit per month" rules="required" v-model="downtimeBenefitPerMonth"
                        inputGroupClasses="uBind-input" />
                </b-col>
            </b-row>


            <b-row v-if="showFreightTask == true">
                <b-col class="less-padding" md="12">
                    <base-input rules="required" label="Do you require Hook Liability extension for this vehicle?"
                        name="Hook Liability" inputGroupClasses="uBind-input">
                        <el-select v-model="hookLiability">
                            <el-option label="Please select" :value="null" />
                            <el-option label="Yes" value="YES" />
                            <el-option label="No" value="NO" />
                        </el-select>
                    </base-input>



                </b-col>

            </b-row>

            <b-row v-if="hookLiability == 'YES'">
                <b-col class="less-padding">
                    <base-input label="Hook Liability Limit" name="Hook Liability Limit" rules="required"
                        v-model="hookLiabilityLimit" inputGroupClasses="uBind-input" />
                </b-col>
            </b-row>




        </div>

        <template v-slot:modal-footer>

            <div v-if="isFormValid == false" class="invalid-feedback" style="display: block;">
                Please complete all required fields before saving. </div>

            <b-button @click="closeVehicleModal()">Cancel</b-button>
            <b-button style="color: white;" type="danger" class="bg-danger" :disabled="!isFormValid"
                @click="saveVehicle()">Save</b-button>
        </template>

    </b-modal>

</template>

<script>
//import MotorContinueQuote from "../../components/MotorContinueQuote.vue";
import BaseInput from "../../../components/Inputs/BaseInput.vue";
import { Select, Option, Tooltip } from "element-ui";
import VueMultiselectComponent from 'vue-multiselect-component'
import { entsiaDropDowns } from "../../../assets/data/entsiaLOVs";

export default {
    name: "VehicleModal",
    //policy_id: "",
    //selectedCustomerId: 0,
    props: {
        showFreightTask: {
            type: Boolean,
            default: true


            //     //selectedItem: null 
            //     _selectedItem: {
            //         type: Object
        },
        vehicleTypeLabelPrefixes: {
            type: Array,
            default: () => []
        },
        hasTrailerLiability: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //value: [],
            dangerousGoods: 'NO',
            hookLiability: 'NO',
            hookLiabilityLimit: '',
            trailerSumInsured: 0,
            businessInterruption: 'NO',
            downtimeBenefitPerMonth: '',
            downTimeMonths: '',
            noClaimsBonus: '',
            dangerousGoodsLimit: '',
            ownTrailer: 'NO',
            isVehicleRegistered: 'NO',
            vehicleEditMode: 'add',
            selectedItem: null,
            selectedIdx: null,
            freightTaskOptions: entsiaDropDowns.freightTaskOptions,
            vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
            dangerousGoodsOptions: entsiaDropDowns.dangerousGoodsLimit,
            carModels: entsiaDropDowns.carModels,
            noClaimsBonusOptions: entsiaDropDowns.noClaimsBonusOptions,
            radiusOfOperation: entsiaDropDowns.radiusOfOperation
            //isFormValid: true
        }
    },
    computed: {
        sumInsuredInput: {
            get() {
                return this.selectedItem && this.selectedItem.vehicle
                    ? this.selectedItem.vehicle.sumInsured
                    : "";
            },
            set(value) {
                if (this.selectedItem && this.selectedItem.vehicle) {
                    this.selectedItem.vehicle.sumInsured = this.sanitiseDecimalInput(value);
                }
            }
        },
        trailerSumInsuredInput: {
            get() {
                return this.trailerSumInsured;
            },
            set(value) {
                this.trailerSumInsured = this.sanitiseDecimalInput(value);
            }
        },
        noAccessoriesChecked() {
            if (!this.selectedItem || !this.selectedItem.vehicle) {
                return true;
            }
            return String(this.selectedItem.vehicle.noAccessories || "YES").toUpperCase() === "YES";
        },
        accessoriesInput: {
            get() {
                return this.selectedItem && this.selectedItem.vehicle
                    ? this.selectedItem.vehicle.accessories || ""
                    : "";
            },
            set(value) {
                if (!this.selectedItem || !this.selectedItem.vehicle) {
                    return;
                }
                this.$set(this.selectedItem.vehicle, "accessories", value);
                if (value && String(value).trim() !== "") {
                    this.$set(this.selectedItem.vehicle, "noAccessories", "NO");
                }
            }
        },
        accessoriesSumInsuredInput: {
            get() {
                return this.selectedItem && this.selectedItem.vehicle
                    ? this.selectedItem.vehicle.accessoriesSumInsured
                    : "";
            },
            set(value) {
                if (!this.selectedItem || !this.selectedItem.vehicle) {
                    return;
                }
                this.$set(
                    this.selectedItem.vehicle,
                    "accessoriesSumInsured",
                    this.sanitiseDecimalInput(value)
                );
            }
        },
        selectedVehicleTypeOption() {
            if (!this.selectedItem || !this.selectedItem.vehicle || !this.selectedItem.vehicle.vehicleType) return null;
            return this.vehicleTypeOptions.find(opt => opt.value === this.selectedItem.vehicle.vehicleType);
        },
        filteredVehicleTypeOptions() {
            if (!this.vehicleTypeLabelPrefixes || this.vehicleTypeLabelPrefixes.length === 0) {
                return this.vehicleTypeOptions;
            }

            return this.vehicleTypeOptions.filter((option) => this.vehicleTypeIsAllowed(option));
        },
        askOwnTrailer() {
            return !!this.selectedItem
                && !!this.selectedItem.vehicle
                && this.selectedItem.vehicle.vehicleType == '3E'
                && !this.hasTrailerLiability;
        },
        selectedVehicleTypeCanBeRegistered() {
            return this.selectedVehicleTypeOption && this.selectedVehicleTypeOption.vehicleCanBeRegistered === true;
        },
        isFormValid() {
            if (this.selectedItem.vehicle.vehicleType == ""
                || (this.showFreightTask == true && this.selectedItem.vehicle.freightTask == "")
                || (this.askOwnTrailer && this.ownTrailer == null)
                || (this.askOwnTrailer && this.ownTrailer == 'YES' && this.trailerSumInsured == '')
                || !this.selectedItem.vehicle.operatingRadius
                || (this.selectedItem.vehicle.motorwebGlasses.registration == "" && this.selectedItem.vehicle.motorwebGlasses.vin == "")
                || this.selectedItem.vehicle.vehiclePostcode == ""
                || this.selectedItem.vehicle.motorwebGlasses.make == ""
                || this.selectedItem.vehicle.motorwebGlasses.family == ""
                || this.selectedItem.vehicle.motorwebGlasses.vehicleYear == ""
                || this.selectedItem.vehicle.sumInsured == ""
            ) {
                return false;
            }

            return true;
        }
    },
    methods: {
        sanitiseDecimalInput(value) {
            const sanitisedValue = String(value || "").replace(/[^0-9.]/g, "");
            const [integerPart, ...decimalParts] = sanitisedValue.split(".");
            return decimalParts.length > 0
                ? integerPart + "." + decimalParts.join("")
                : integerPart;
        },
        ensureAccessoriesFields() {
            if (!this.selectedItem || !this.selectedItem.vehicle) {
                return;
            }
            if (!this.selectedItem.vehicle.motorwebGlasses) {
                this.$set(this.selectedItem.vehicle, "motorwebGlasses", {});
            }
            if (this.selectedItem.vehicle.motorwebGlasses.variant == null) {
                this.$set(this.selectedItem.vehicle.motorwebGlasses, "variant", "");
            }
            if (this.selectedItem.vehicle.motorwebGlasses.style == null) {
                this.$set(this.selectedItem.vehicle.motorwebGlasses, "style", "");
            }
            if (this.selectedItem.vehicle.noAccessories == null) {
                const hasAccessories = !!(this.selectedItem.vehicle.accessories && String(this.selectedItem.vehicle.accessories).trim());
                this.$set(this.selectedItem.vehicle, "noAccessories", hasAccessories ? "NO" : "YES");
            }
            if (this.selectedItem.vehicle.accessories == null) {
                this.$set(this.selectedItem.vehicle, "accessories", "");
            }
            if (this.selectedItem.vehicle.accessoriesSumInsured == null) {
                this.$set(this.selectedItem.vehicle, "accessoriesSumInsured", "");
            }
        },
        onNoAccessoriesChange(checked) {
            if (!this.selectedItem || !this.selectedItem.vehicle) {
                return;
            }
            if (checked) {
                this.$set(this.selectedItem.vehicle, "noAccessories", "YES");
                this.$set(this.selectedItem.vehicle, "accessories", "");
                this.$set(this.selectedItem.vehicle, "accessoriesSumInsured", "");
            } else {
                this.$set(this.selectedItem.vehicle, "noAccessories", "NO");
            }
        },
        vehicleTypeChanged() {
            if (!this.selectedItem || !this.selectedItem.vehicle || !this.selectedVehicleTypeOption) {
                return;
            }

            // Bus/Coach must not default to General Non Hazardous on the create form
            // (freight task field is often hidden via showFreightTask=false).
            if (String(this.selectedVehicleTypeOption.label || "").startsWith("Bus/Coach")) {
                this.selectedItem.vehicle.freightTask = "BU-BUS";
            }
        },
        isBusCoachVehicleType() {
            return String(
                (this.selectedVehicleTypeOption && this.selectedVehicleTypeOption.label) || ""
            ).startsWith("Bus/Coach");
        },
        vehicleTypeIsAllowed(option) {
            if (!this.vehicleTypeLabelPrefixes || this.vehicleTypeLabelPrefixes.length === 0) {
                return true;
            }

            const label = String(option && option.label || "");
            return this.vehicleTypeLabelPrefixes.some((prefix) => label.startsWith(prefix));
        },
        clearVehicleTypeIfNotAllowed() {
            if (!this.selectedItem || !this.selectedItem.vehicle || !this.selectedVehicleTypeOption) {
                return;
            }

            if (!this.vehicleTypeIsAllowed(this.selectedVehicleTypeOption)) {
                this.selectedItem.vehicle.vehicleType = "";
            }
        },
        sumInsuredChanged(evt) {
            //console.log(evt);
            const sumInsured = this.sanitiseDecimalInput(evt.target.value);
            this.selectedItem.vehicle.sumInsured = sumInsured;
            this.selectedItem.vehicle.basicExcess = this.calculateExcess(parseFloat(sumInsured));
        },
        calculateExcess(sumInsured) {
            if (sumInsured && sumInsured > 0) {
                if (this.selectedVehicleTypeCanBeRegistered == true) {
                    var minExcess = 500;
                    var calcExcess = (sumInsured * 0.01);
                    if (calcExcess > minExcess) {
                        return calcExcess.toFixed(0);
                    }
                    return minExcess;
                } else {
                    var minExcess = 1250;
                    var calcExcess = (sumInsured * 0.01);
                    if (calcExcess > minExcess) {
                        return calcExcess.toFixed(0);
                    }
                    return minExcess;
                }


            } else {
                return 0
            }
        },
        saveVehicle() {

            if (this.showFreightTask == false) {
                // Create-quote hides freight task; default non-bus to General Non Hazardous.
                // Bus/Coach must use Bus & Coach freight task, not GC-GENERAL.
                this.selectedItem.vehicle.freightTask = this.isBusCoachVehicleType()
                    ? "BU-BUS"
                    : "GC-GENERAL";
            }


            this.selectedItem.vehicle.vehicleDowntimeRequired = this.businessInterruption;

            //console.log("blah: " + this.selectedItem.vehicle.vehicleDowntimeRequired);

            //console.log(this.downTimeMonths);
            //  console.log(parseFloat(this.downtimeBenefitPerMonth));

            if (this.selectedItem.vehicle.vehicleDowntimeRequired == "YES") {
                this.selectedItem.vehicle.indemnityPeriod = this.downTimeMonths;
                this.selectedItem.vehicle.monthlyBenefit = parseFloat(this.downtimeBenefitPerMonth);
            } else {
                delete this.selectedItem.vehicle.indemnityPeriod;
                delete this.selectedItem.vehicle.monthlyBenefit;
            }


            this.selectedItem.vehicle.isDangerousAndHazardousGoods = this.dangerousGoods;
            //if (this.selectedItem.vehicle.isDangerousAndHazardousGoods == "YES") {
            this.selectedItem.vehicle.dangerousGoodsLimit = this.dangerousGoodsLimit;
            //}


            this.selectedItem.vehicle.hookLiability = this.hookLiability;

            if (this.selectedItem.vehicle.hookLiability == "YES") {
                this.selectedItem.vehicle.hookLiabilityLimit = parseFloat(this.hookLiabilityLimit);
            } else {
                delete this.selectedItem.vehicle.hookLiabilityLimit;
            }


            this.selectedItem.vehicle.ncb = this.noClaimsBonus;

            this.selectedItem.vehicle.isVehicleRegistered = this.isVehicleRegistered;

            this.ensureAccessoriesFields();
            if (String(this.selectedItem.vehicle.noAccessories || "YES").toUpperCase() === "YES") {
                this.selectedItem.vehicle.noAccessories = "YES";
                this.selectedItem.vehicle.accessories = "";
                delete this.selectedItem.vehicle.accessoriesSumInsured;
            } else {
                this.selectedItem.vehicle.noAccessories = "NO";
                const accessoriesSum = parseFloat(this.selectedItem.vehicle.accessoriesSumInsured);
                if (!isNaN(accessoriesSum) && accessoriesSum > 0) {
                    this.selectedItem.vehicle.accessoriesSumInsured = accessoriesSum;
                } else {
                    delete this.selectedItem.vehicle.accessoriesSumInsured;
                }
            }

            this.$emit('saveVehicle', this.selectedItem, this.ownTrailer, this.trailerSumInsured);
            this.$refs['vehicle-modal'].hide();
        },
        closeVehicleModal() {
            this.$refs['vehicle-modal'].hide();
        },
        openVehicleModal(_mode, _item, _idx) {


            console.log(_item.vehicle.vehicleType);

            this.vehicleEditMode = _mode;
            this.selectedItem = _item;
            this.selectedIdx = _idx;
            this.clearVehicleTypeIfNotAllowed();
            this.ensureAccessoriesFields();

            if (_mode == "edit") {
                this.isVehicleRegistered = (this.selectedItem.vehicle.isVehicleRegistered || 'NO').toUpperCase();
                this.businessInterruption = this.selectedItem.vehicle.vehicleDowntimeRequired.toUpperCase();
                this.downTimeMonths = this.selectedItem.vehicle.indemnityPeriod;
                this.downtimeBenefitPerMonth = this.selectedItem.vehicle.monthlyBenefit;

                this.hookLiability = this.selectedItem.vehicle.hookLiability.toUpperCase();
                this.hookLiabilityLimit = this.selectedItem.vehicle.hookLiabilityLimit;


                this.dangerousGoods = this.selectedItem.vehicle.isDangerousAndHazardousGoods.toUpperCase()
                this.dangerousGoodsLimit = this.selectedItem.vehicle.dangerousGoodsLimit;



            } else {
                this.ownTrailer = "NO";
                this.isVehicleRegistered = "NO";
                this.$set(this.selectedItem.vehicle, "noAccessories", "YES");
                this.$set(this.selectedItem.vehicle, "accessories", "");
                this.$set(this.selectedItem.vehicle, "accessoriesSumInsured", "");
            }

            this.noClaimsBonus = this.selectedItem.vehicle.ncb;

            this.$refs['vehicle-modal'].show();
        },
    },
    components: {
        BaseInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
        //Spinner,
        //FileUpload,
        VueMultiselectComponent
    },
    async mounted() {

        //this.businessInterruption = 'No';
        //this.downtimeBenefitPerMonth = '';
        //console.log("c13");
        //this.$refs['vehicle-modal'].show();

        //console.log(this._selectedItem);
        //this.selectedItem = this._selectedItem;
    }
};
</script>
<style lang="scss">
.modal {
    ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 10px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, .5);
        box-shadow: 0 0 1px rgba(255, 255, 255, .5);
    }
}

.accessories-info-hint {
    border-bottom: 1px dotted #525f7f;
    cursor: help;
    margin-left: 2px;
}
</style>
